import { CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import MaterialTypography from "../../../components/MaterialTypography"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import { useWorkflowStepFormHandling } from "./components/WorkflowStepStateHandle.js";
import MaterialSelect from "../../../components/MasterSelect/index.js"
import MaterialInput from "../../../components/MaterialInput/index.js"
import MaterialButton from "../../../components/MaterialButton/index.js"
import MaterialBox from "../../../components/MaterialBox/index.js"
import { fetchData, fetchDataById, postData, putData } from "../../../services/index.js"
import { useEffect, useState } from "react"
import DropDownConfig from "../../Utils/DropDownConfig.js"

const WorkflowStepForm = () => {

    const [searchParams] = useSearchParams();
    const workflowStepId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();
    const [workflowDictionaryOptions, setWorkflowDictionaryOptions] = useState([]);
    const [stepTypeOptions, setStepTypeOptions] = useState([]);
    const [schemaOptions, setSchemaOptions] = useState([]);
    const { formData, setFormData, handleChange, checkAllFields } = useWorkflowStepFormHandling();
    
    useEffect(() => {
        if(pageMode === "view"){
            return
        }
        fetchAllDropdowns();
    }, [pageMode]);

    useEffect(() => {
        if (pageMode === "add" || !workflowStepId) {
            return;
        }
        //Fetch data by Id
        const fetchWorkflowStepById = async (workflowStepId) => {
            try {
            setCircleLoading(true);
            const response = await fetchDataById(`/reference/orchestration/work-flow-steps/${workflowStepId}`);

            const responseData = response?.data;
            
            if (response.success) {
                const mapped = {
                    stepCode: responseData?.stepCode || "",
                    stepName: responseData?.stepName || "",
                    stepOrder: responseData?.stepOrder || "",
                    isParallel: responseData?.isParallel,
                    isOptional: responseData?.isOptional,

                    // dropdowns (reverse of payload)
                    workflowDictionaryId: responseData?.workflowDefinition
                    ? { value: responseData.workflowDefinition.id, label: responseData.workflowDefinition.name }
                    : null,

                    stepTypeId: responseData?.stepType
                    ? { value: responseData.stepType?.id, label: responseData.stepType?.keyName }
                    : null,

                    schemaId: responseData?.schema?.id
                    ? { value: responseData.schema.id, label: responseData.schema.name }
                    : null,
                    config: responseData?.config,

                    isActive: responseData?.isActive,

                    // status fields
                    stepCodeStatus: responseData?.stepCode ? "success" : "unchecked",
                    stepNameStatus: responseData?.stepName ? "success" : "unchecked",
                    stepOrderStatus: responseData?.stepOrder ? "success" : "unchecked",
                    workflowDictionaryIdStatus: responseData?.workflowDefinition.id ? "success" : "unchecked",
                    stepTypeIdStatus: responseData?.stepType?.id ? "success" : "unchecked",
                    schemaIdStatus: responseData?.schema?.id ? "success" : "unchecked",
                    configStatus: responseData?.config ? "success" : "unchecked",
                };

                setFormData(mapped);  
            }
            } catch (error) {
            console.error("Error fetching data by ID:", error);
            showSnackbar(error?.response?.data?.message || "Network Error","error");
            }finally{
                setCircleLoading(false);
            }
        };
        fetchWorkflowStepById(workflowStepId);
    }, [pageMode]);

    //all dropdown api function
    const fetchAllDropdowns = async () => {
        setCircleLoading(true);

        try {
            const [
            firstResponse,
            secondResponse,
            thirdResponse
            ] = await Promise.allSettled([
            fetchData(`/orchestration/work-flow-dictionary?dropdown=true&isActive=true`),
            fetchData(`/orchestration/key-value-store?code=${DropDownConfig?.operationWorkflowStepType}&dropdown=true&isActive=true`),
            fetchData(`/api-engine/schema?dropdown=true&isActive=true`)
            ]);

            const formattedDictionaries = firstResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.name
            })) || [];
            
            const formattedStepTypes = secondResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName
            })) || [];

            const formattedSchemas = thirdResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.name
            })) || [];

            
            setWorkflowDictionaryOptions(formattedDictionaries);
            setStepTypeOptions(formattedStepTypes);
            setSchemaOptions(formattedSchemas);

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar("Error fetching Dropdown", "warning");
        } finally {
            setCircleLoading(false);
        }
    };

    const handleWorkflowStepSubmit = async () => {
        const payload = {
            workflowDictionaryId: formData?.workflowDictionaryId?.value,
            stepCode: formData?.stepCode,
            stepName: formData?.stepName,
            stepTypeId: formData?.stepTypeId?.value,
            stepOrder: parseInt(formData?.stepOrder),
            isParallel: formData?.isParallel,
            isOptional: formData?.isOptional,
            config: JSON.parse(formData?.config),
            schemaId: formData?.schemaId?.value,
            isActive: formData?.isActive,
        }
        //Update
        if(workflowStepId){
            try {
                const response = await putData(`/reference/orchestration/work-flow-steps/${workflowStepId}`, payload);
                
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/operation/workflow-step');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error")
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar("Error Updating","error");
            }
        }
        else{      
        //Submit
            try {
                const response = await postData('/reference/orchestration/work-flow-steps', payload);
                
                const responseMessage = response?.message;
                if(response?.success){
                    //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/operation/workflow-step');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                console.error('Error posting data:', error);
                //catch error message
                showSnackbar(error?.response?.data?.message || "Network Error","error")
            }
        }
    }

  return (
    <DashboardLayout>
        <CardHeader
        title={
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton onClick={() => navigate("/operation/workflow-step")}>
                        <ArrowBack />
                    </IconButton>
                    <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Workflow Step Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        Enter New Workflow Step Details.
                    </MaterialTypography>
                    </Stack>
                </Stack>
            </Stack>
        }
        />
        <CardContent>
            <Grid2 container spacing={1}>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Step Name*
                    </MaterialTypography>
                    <MaterialInput
                        name="stepName"
                        placeholder="eg. Step Name"
                        value={formData.stepName}
                        onChange={handleChange}
                        success={formData.stepNameStatus === "success"}
                        error={formData.stepNameStatus === "error"}
                        disabled={pageMode === "view"}
                    />
                    {formData.stepNameStatus === "error" && (
                        <FormControl error>
                            <FormHelperText>
                                Step Name should be a minimum 1 character & maximum 100 characters long.
                            </FormHelperText>
                        </FormControl>
                    )}
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold">
                        Step Code*
                    </MaterialTypography>
                    <MaterialInput
                    name="stepCode"
                    placeholder="eg. CODE101"
                    value={formData.stepCode}
                    onChange={handleChange}
                    success={formData.stepCodeStatus === "success"}
                    error={formData.stepCodeStatus === "error"}
                    disabled={pageMode === "view"}
                    />
                    {formData.stepCodeStatus === "error" && (
                        <FormControl error>
                            <FormHelperText>
                            Step Code should be a minimum 1 character & maximum 50
                            characters long.
                            </FormHelperText>
                        </FormControl>
                    )}
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Workflow Dictionary*
                    </MaterialTypography>
                    <MaterialSelect
                    name="workflowDictionaryId"
                    value={formData.workflowDictionaryId}
                    onChange={handleChange}
                    options={workflowDictionaryOptions}
                    success={formData.workflowDictionaryIdStatus === "success"}
                    error={formData.workflowDictionaryIdStatus === "error"}
                    isDisabled={pageMode === "view"}
                    />
                </Grid2> 
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Step Type*
                    </MaterialTypography>
                    <MaterialSelect
                    name="stepTypeId"
                    value={formData.stepTypeId}
                    onChange={handleChange}
                    options={stepTypeOptions}
                    success={formData.stepTypeIdStatus === "success"}
                    error={formData.stepTypeIdStatus === "error"}
                    isDisabled={pageMode === "view"}
                    />
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold">
                        Step Order*
                    </MaterialTypography>
                    <MaterialInput
                    name="stepOrder"
                    placeholder="eg. 1"
                    value={formData.stepOrder}
                    onChange={handleChange}
                    success={formData.stepOrderStatus === "success"}
                    error={formData.stepOrderStatus === "error"}
                    disabled={pageMode === "view"}
                    type="number"
                    />
                    {formData.stepOrderStatus === "error" && (
                        <FormControl error>
                            <FormHelperText>
                            Step Order should be a minimum 1 character & maximum 50
                            characters long.
                            </FormHelperText>
                        </FormControl>
                    )}
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Schema*
                    </MaterialTypography>
                    <MaterialSelect
                    name="schemaId"
                    value={formData.schemaId}
                    onChange={handleChange}
                    options={schemaOptions}
                    success={formData.schemaIdStatus === "success"}
                    error={formData.schemaIdStatus === "error"}
                    isDisabled={pageMode === "view"}
                    />
                </Grid2>
                <Grid2 size={{lg:2, md:2, sm: 4, xs: 4 }}>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold">
                        Parallel
                    </MaterialTypography>
                    <FormControlLabel
                    control={
                        <Switch
                            checked={formData.isParallel}
                            disabled={pageMode === "view"}
                            onChange={(e) =>
                                handleChange({
                                    target: {
                                        name: "isParallel",
                                        value: e.target.checked,
                                    },
                                })
                            }
                            color="primary"
                        />
                    }
                    label={
                        <MaterialTypography variant="caption" fontWeight="bold">
                            {formData?.isParallel ? "Yes" : "No"}
                        </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                    />
                </Grid2>
                <Grid2 size={{lg:2, md:2, sm: 4, xs: 4 }}>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold">
                        Optional
                    </MaterialTypography>
                    <FormControlLabel
                    control={
                        <Switch
                            checked={formData.isOptional}
                            disabled={pageMode === "view"}
                            onChange={(e) =>
                                handleChange({
                                    target: {
                                        name: "isOptional",
                                        value: e.target.checked,
                                    },
                                })
                            }
                            color="primary"
                        />
                    }
                    label={
                        <MaterialTypography variant="caption" fontWeight="bold">
                            {formData?.isOptional ? "Yes" : "No"}
                        </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                    />
                </Grid2>
                <Grid2 size={{lg:2, md:2, sm: 4, xs: 4 }}>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold">
                        Active
                    </MaterialTypography>
                    <FormControlLabel
                    control={
                        <Switch
                            checked={formData.isActive}
                            disabled={pageMode === "view"}
                            onChange={(e) =>
                                handleChange({
                                    target: {
                                        name: "isActive",
                                        value: e.target.checked,
                                    },
                                })
                            }
                            color="primary"
                        />
                    }
                    label={
                        <MaterialTypography variant="caption" fontWeight="bold">
                            {formData?.isActive ? "Yes" : "No"}
                        </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                    />
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold">
                        Configuration*
                    </MaterialTypography>
                    <MaterialInput
                    name="config"
                    placeholder={`eg. {    "url": "https://example.com/api",
            "retries": 3
        }`}
                    value={formData.config}
                    onChange={handleChange}
                    success={formData.configStatus === "success"}
                    error={formData.configStatus === "error"}
                    disabled={pageMode === "view"}
                    multiline
                    rows={3}
                    />
                    {formData.configStatus === "error" && (
                        <FormControl error>
                            <FormHelperText>
                            Configuration should be a minimum 1 character & maximum 150
                            characters long.
                            </FormHelperText>
                        </FormControl>
                    )}
                </Grid2>
            </Grid2>
        </CardContent>
        <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        >
            {pageMode !== "view" && (
            <>
                <MaterialButton
                sx={{ m: 2 }}
                variant="outlined"
                color="dark"
                onClick={() => navigate("/operation/workflow-step")}
                >
                Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleWorkflowStepSubmit}
                >
                {pageMode === "edit" ? "Update" : "Submit"}
                </MaterialButton>
            </>
            )}
        </MaterialBox>
    </DashboardLayout>
  )
}

export default WorkflowStepForm